module.exports = __webpack_public_path__ + "static/media/lodgings.f8ba0d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lodgings.png
// module id = 607
// module chunks = 0